<template>
  <v-col :sm="sm" :cols="cols">
    <v-card flat tile :color="$vuetify.theme.dark ? '#172233' : '#F1F7FB'" class="reg-details-profile-bar">
      <v-card-actions class="pl-5 align-start py-1">
        <v-card-text class="px-0 py-0">
          <v-card-title
            :class="personalinfo.userDocStatus === 'Not verified' ? 'error-title' : personalinfo.userDocStatus === 'Pending' ? 'text-warning' : 'text--green'">
            {{ personalinfo.userDocStatus }}
            <v-tooltip v-if="tooltip" top color="#ff567f">
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-2" small color="#708AA7" v-bind="attrs" v-on="on">
                  mdi mdi-information-outline
                </v-icon>
              </template>
              <span>Tooltip</span>
            </v-tooltip>
          </v-card-title>
          <v-card-subtitle>Verification Status</v-card-subtitle>
        </v-card-text>

        <!-- IB Status -->
        <v-card-text class="px-0 py-0">
          <v-card-title :class="personalinfo.userIbStatus === 'Approved' ? 'text--green' : 'error-title'">
            {{ personalinfo.userIbStatus }}
            <v-tooltip v-if="tooltip" top color="#ff567f">
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-2" small color="#708AA7" v-bind="attrs" v-on="on">
                  mdi mdi-information-outline
                </v-icon>
              </template>
              <span>Tooltip</span>
            </v-tooltip>
          </v-card-title>
          <v-card-subtitle>IB Status</v-card-subtitle>
        </v-card-text>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { REGISTERUSERDETAILS__ACTIONS, ALLNEWUSER__ACTIONS } from "@/store/action-types";

export default {
  computed: {
    ...mapState("reguserdetails", ["personalinfo"]),
  },
  methods: {
    ...mapActions("reguserdetails", [REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO]),
    // ...mapActions("dashboard", [ALLNEWUSER__ACTIONS.REMOVENEWUSER]),
  },
  async mounted() {
    const userId = this.$route.params.id;
    await this[REGISTERUSERDETAILS__ACTIONS.REGPERSONALINFO](userId);
    // await this[ALLNEWUSER__ACTIONS.REMOVENEWUSER](userId)
  },
};
</script>